module.exports = __webpack_public_path__ + "6a4c06537aad71c5f422cc77ab062e04.jpg";